<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12">
          <GradeClassStudentSelect disableStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Chọn xem
      </v-btn>
    </div>
  </div>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {}
  }),
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        grade: this.selectedGrade,
        class: this.selectedClass
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
